<template>
  <div class="content">
    <div class="box">
      <div class="toptitle">{{ $t('About.maptext') }}</div>
      <span class="number">102</span>
      <span class="bottomtitle">{{ $t('About.maptext2') }}</span>
    </div>
    <div class="mapimg">
      <img src="https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/map.png" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  width: calc(100% - 3.3rem);
  margin-top: 5rem;

  .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  .toptitle {
    color: #202020;
    font-family: PingFang SC;
    font-size: 2.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 3.4rem;
  }

  .number {
    color: #000;
    text-align: center;
    font-family: -apple-system, PingFang SC, BlinkMacSystemFont, Helvetica Neue, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, sans-serif;
    font-size: 12.8rem;
    font-style: normal;
    font-weight: 510;
    line-height: 9.6rem;
    margin-top: 5rem;
    margin-bottom: 1.2rem;
  }

  .bottomtitle {
    color: #717171;
    text-align: center;
    font-family: PingFang SC;
    font-size: 2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 5rem;
  }

  .mapimg {
    width: 100%;
    margin-top: 2rem;
    display: flex;
    justify-content: center;

    img {
      width: 100%;
      max-width: 120rem;
    }
  }
}
</style>
